import { render, staticRenderFns } from "./DeliriumOrbs.vue?vue&type=template&id=3daa41d4&"
import script from "./DeliriumOrbs.vue?vue&type=script&lang=js&"
export * from "./DeliriumOrbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports